




































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Button, Checkbox } from 'element-ui';

import { BillFields } from '@/types/graphql/schemaTypes';

import ModalCard from '@/components/layout/ModalCard.vue';

@Component({
  components: {
    ModalCard,
    'el-button': Button,
    'el-checkbox': Checkbox
  }
})
export default class BillComplete extends Vue {
  @Prop() private bill!: BillFields;
  @Prop({ default: false, type: Boolean }) open!: boolean;
  @Prop({ default: false, type: Boolean }) isLoading!: boolean;

  private billIncomplete = false;

  private close(): void {
    this.$emit('close');
  }

  private submit(): void {
    this.$emit('publishBill', this.billIncomplete);
  }
}
